var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"w-table-data-footer fixed-sum-table-row"},[_vm._t("footer-inner-append",function(){return _vm._l((_vm.headers),function(header,index){return _c('td',{key:index,class:_vm.getClasses(header)},[_c('span',[_vm._v(_vm._s(_vm.getAggregation(header)))])])})},{"aggregations":_vm.aggregations})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }